// Not exposing the promise function directly in order to be able to do td.replace(GetScript, 'JS') on tests
export default {
    JS(url) {
        return new Promise((resolve, reject) => {
            // create new script element, which will load our script
            // and execute it globally
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.setAttribute('defer', 'defer');
            script.onerror = () => reject('Failed!');
            script.onload = () => resolve('Success!');

            document.body.appendChild(script);
            script.src = url;
        });
    },
    CSS(href) {
        return new Promise((resolve, reject) => {
            // create new link element, which will load our styles
            // and execute it globally
            const link = document.createElement('link');
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('type', 'text/css');
            link.setAttribute('media', 'none');
            link.setAttribute('href', href);
            link.onerror = () => reject('Failed!');
            link.onload = () => {
                /* istanbul ignore else  */
                if (link.media !== 'all') link.media = 'all';
                resolve('Success!');
            };

            document.body.appendChild(link);
        });
    },
};
